import React, { useState, useEffect } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import Geolocate from '../menus/topSubMenuComponents/geolocate.js';
import Compass from '../menus/topSubMenuComponents/compass.js';

const GeneralNav = ({
    globalRefs,
    globalState,
    selectedYearEditing,
    mapbearing,
    ResetMap
}) => {
    const [isMapViewActive, setIsMapViewActive] = useState(false);

    let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;

    let is2DViewActive = globalState.is2DViewActive;
    let setIs2DViewActive = globalState.setIs2DViewActive;
    let mapRef = globalRefs.mapRef;

    const toggle2DView = () => {
        const newIs2DViewActive = !is2DViewActive;
        setIs2DViewActive(newIs2DViewActive);
        if (newIs2DViewActive) {
            polygonCustomLayerRef.current.setCameraTo2DView();
            // 2D mode: allow panning only
            mapRef.current.dragRotate.disable();
            mapRef.current.touchZoomRotate.disableRotation();
        } else {
            polygonCustomLayerRef.current.setCameraTo3DView();
            // 3D mode: restore rotation
            mapRef.current.dragRotate.enable();
            mapRef.current.touchZoomRotate.enableRotation();
        }
        ResetMap(
            globalRefs,
            {
                ...globalState,
                is2DViewActive: newIs2DViewActive
            }
        );
    };

    const toggleMapView = (viewType) => {
        setIsMapViewActive(false);
        let mapbase = 'Map';
        polygonCustomLayerRef.current.swapMapBase(mapbase);
    };

    const toggleSatView = (viewType) => {
        setIsMapViewActive(true);
        let mapbase = 'Satellite';
        polygonCustomLayerRef.current.swapMapBase(mapbase);
    };

    let mobileStatus = isMobile ? "mobile" : "not-mobile";

    if (isTablet) {
        mobileStatus = "not-mobile";
    }

    return (
        <>
            <div className={`general_nav ${mobileStatus}`}>
                <>
                    <button className="gnav_button" onClick={() => toggle2DView()}>
                        <div className={`gnav_mv_toggle ${is2DViewActive ? 'active' : ''}`}>2D</div>
                    </button>
                    <button className="gnav_button" onClick={() => toggle2DView()}>
                        <div className={`gnav_mv_toggle ${is2DViewActive ? '' : 'active'}`}>3D</div>
                    </button>
                    <button className="gnav_button" onClick={() => toggleMapView('Map')}>
                        <div className={`gnav_mv_toggle ${isMapViewActive ? '' : 'active'}`}>Map</div>
                    </button>
                    <button className="gnav_button" onClick={() => toggleSatView('Satellite')}>
                        <div className={`gnav_mv_toggle ${isMapViewActive ? 'active' : ''}`}>Satellite</div>
                    </button>

                    <Geolocate
                        globalRefs={globalRefs}
                        globalState={globalState}
                    />

                    <Compass
                        globalRefs={globalRefs}
                        globalState={globalState}
                        mapbearing={mapbearing}
                    />

                </>
            </div>
        </>
    );
};

export default GeneralNav;
